import(/* webpackMode: "eager", webpackExports: ["QuarkleLogo","QuarkleWordmark"] */ "/vercel/path0/src/components/Brand.jsx");
